/* =========================================================
   meliora 商品ページ
   画像上のバッジと NEW バッジを商品名の上へ移動する
   ※ PC用・SP用で .top-left が複数あるため、全てに複製して入れる
   2026-08-18
   ========================================================= */
(function () {
  'use strict';

  function collectHtml(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('.mlr-badge'));
  }

  function run() {
    var lefts = document.querySelectorAll('#product-information .information-top .top-left');
    if (!lefts.length) return;

    var newSrc = document.getElementById('mlr-badge-new-src');
    var imgSrcs = document.querySelectorAll('.mlr-badge-img');

    /* NEW を先頭、その後に既存バッジ */
    var badges = collectHtml(newSrc);
    Array.prototype.forEach.call(imgSrcs, function (s) {
      badges = badges.concat(collectHtml(s));
    });
    if (!badges.length) return;

    var placed = 0;
    Array.prototype.forEach.call(lefts, function (left) {
      if (left.querySelector('.mlr-badge-top')) return;
      var title = left.querySelector('h1.title');
      if (!title) return;

      var wrap = document.createElement('div');
      wrap.className = 'mlr-badge-top';
      badges.forEach(function (b) { wrap.appendChild(b.cloneNode(true)); });
      title.parentNode.insertBefore(wrap, title);
      placed++;
    });

    if (!placed) return;

    /* 複製元を片付ける */
    if (newSrc && newSrc.parentNode) newSrc.parentNode.removeChild(newSrc);
    Array.prototype.forEach.call(imgSrcs, function (s) {
      if (s.parentNode) s.parentNode.removeChild(s);
    });
  }

  function boot() {
    run();
    /* テーマが遅延でDOMを組み直すケースに備えて数回再試行 */
    var n = 0;
    var t = setInterval(function () {
      run();
      if (++n > 10) clearInterval(t);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
